import { createFileRoute } from '@tanstack/react-router';
import { Blog } from '@/app/pages/blog/Blog.page';

export const Route = createFileRoute('/blog/')({
    component: Blog,
});

